// generated by bun run generate from the SwiftUI SDK and codegen/catalog.ts.
// edit the generator or catalog, then regenerate.
import type { ViewProps } from 'react-native';
import type { DirectEventHandler, Int32 } from 'react-native/Libraries/Types/CodegenTypes';
import codegenNativeComponent from 'react-native/Libraries/Utilities/codegenNativeComponent';
interface NativeProps extends ViewProps {
  selection: string;
  acknowledgedEvent: Int32;
  revision: Int32;
  onNativePagerSelectionChange?: DirectEventHandler<Readonly<{
    selection: string;
    eventCount: Int32;
    revision: Int32;
  }>>;
}
const NativeComponentRegistry = require('react-native/Libraries/NativeComponent/NativeComponentRegistry');
const {
  ConditionallyIgnoredEventHandlers
} = require('react-native/Libraries/NativeComponent/ViewConfigIgnore');
let nativeComponentName = 'OneNativeSwiftPager';
export const __INTERNAL_VIEW_CONFIG = {
  uiViewClassName: "OneNativeSwiftPager",
  directEventTypes: {
    topNativePagerSelectionChange: {
      registrationName: "onNativePagerSelectionChange"
    }
  },
  validAttributes: {
    selection: true,
    acknowledgedEvent: true,
    revision: true,
    ...ConditionallyIgnoredEventHandlers({
      onNativePagerSelectionChange: true
    })
  }
};
export default NativeComponentRegistry.get(nativeComponentName, () => __INTERNAL_VIEW_CONFIG);